export interface UnsavedPopStateGuardInput {
  isDirty: boolean
  isConfirming: boolean
  historyState: unknown
  targetUrl: string
  stableUrl: string
}

const hasSynapDialogHistoryState = (state: unknown): boolean => {
  if (!state || typeof state !== 'object') {
    return false
  }

  const maybeState = state as Record<string, unknown>
  const overlay = maybeState.synapOverlay
  // BACK-12: `synapOverlay` objeto (pilha única), `true` (legado) ou string (ex.: 'aiResult').
  const hasOverlayMarker =
    overlay === true || typeof overlay === 'string' || (typeof overlay === 'object' && overlay !== null)
  return maybeState.synapDialog === true || maybeState.synapMobileMenu === true || hasOverlayMarker
}

export const shouldPromptUnsavedChangesOnPopState = ({
  isDirty,
  isConfirming,
  historyState,
  targetUrl,
  stableUrl,
}: UnsavedPopStateGuardInput): boolean => {
  if (!isDirty) return false
  if (isConfirming) return false
  if (hasSynapDialogHistoryState(historyState)) return false
  if (!stableUrl) return false

  // Ignore duplicated popstate for the same URL to avoid dialog loops.
  return targetUrl !== stableUrl
}
